<!--<template>
  <div>
    <form
      class="login"
      @submit.prevent="login">
      <h1>Sign in</h1>
      <label>User name</label>
      <input
        v-model="username"
        required
        type="text"
        placeholder="yourermail@email.com">
      <label>Password</label>
      <input
        v-model="password"
        required
        type="password"
        placeholder="Password">
      <hr>
      <button type="submit">Login</button>
    </form>
  </div>
</template>
-->
<template>
  <v-app>
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-flex xs-3/>
        <v-flex xs-6>
          <v-row
            align="center"
            justify="center"
            style="background-color:green; width:100%"
          >
            <v-col
              cols="4"
              align="center"
              justify="center"
            >
              <v-card class="elevation-12">

                <v-toolbar
                  flat
                  color="#f1f1f1"
                >
                  <v-toolbar-title >Login Tool Management</v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <img src="https://www.cruing.com/wp-content/themes/cruing/assets/images/logo-footer.png" >
                  <v-form>
                    <v-text-field
                      v-model ="email"
                      label="Email Address"
                      prepend-icon="mdi-email"
                      type="text"
                    />

                    <v-text-field
                      id="password"
                      v-model ="password"
                      label="Password"
                      prepend-icon="mdi-lock"
                      type="password"
                    />
                  </v-form>
                  {{ messaggio }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="#004876"
                    @click="login" >Login</v-btn>

                </v-card-actions>
                <v-card-footer>
                  <div
                    v-if="loggingin"
                    class="text-xs-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                    Logging in...
                  </div>
                  <div v-if="!loggingin"> <router-link to="/sign-up">or signup as new user</router-link></div>
                  <div v-if="!loggingin">
                    <v-btn
                      color="secondary"
                      flat
                      @click="pwdreset()">or click here to recover the password
                    </v-btn>
                  </div>
                </v-card-footer>
              </v-card>

            </v-col>

          </v-row>
          <v-row v-if="false">
            <v-col
              align="center"
              justify="center">
              <v-card>
                <div class="text-xs-center">
                  <a href="http://www.cruing.com/old/toolman/login.php">Clicca qui per accedere alla versione 1.0 del tool Management.<br>Click here to access to previous version of tool management</a>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
        <v-flex xs-6/>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>

import firebase from 'firebase/app'
import { Firebase } from '../plugins/firebase'
export default {

  data: () => ({
    email: '',
    password: '',
    source: '',
    messaggio: '',
    loggingin: false
  }),
  methods: {
    cu () {
      Firebase.getCurrentUser().then(x => {
        console.log(x)
      })
    },
    login: async function () {
      const thisp = this
      thisp.messaggio = ''
      console.log('"FIREBASE"', firebase)
      // Firebase.auth().setPersistence(Firebase.auth.Auth.Persistence.SESSION).then(p => {
      console.log('LOgGING IN')
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          console.log('LOGIN DONE')
          thisp.loggingin = true
          // this.$router.push('/')
          firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)
            .then(function (idToken) {
              var cred = { email: thisp.email, password: thisp.password, token: idToken }
              thisp.$store.dispatch('AUTH_REQUEST', cred)
                .then((token) => {
                  thisp.$router.push('/')
                })
                .catch(err => {
                  thisp.loggingin = false
                  thisp.messaggio = err.message
                  console.log(err.message)
                })
            })
            .catch(err => {
              thisp.loggingin = false
              thisp.messaggio = err.message
              console.log(err.message)
            })
        }
        )
        .catch(err => {
          thisp.loggingin = false
          thisp.messaggio = err.message
          console.log(err.message)
        })

    /*
      var cred = { username: this.username, password: this.password }
      this.$store.dispatch('AUTH_REQUEST', cred)
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => console.log(err))
      */
    },
    pwdreset: function () {
      this.messaggio = ''
      const thisp = this
      if (this.email) {
        firebase.auth().sendPasswordResetEmail(this.email).then(function () {
          thisp.messaggio = 'mail sent'
        }).catch(function (error) {
          thisp.messaggio = error.message
        })
      } else {
        thisp.messaggio = 'you must provide a valid mail address'
      }
    }
  }
}
</script>
